import { IconValueProps } from 'spindl-shared-components';
import { FILTER_DROPDOWN_OPTIONS } from '../../../lib/constants';
import { booleanToOptionText } from '../../../lib/utils';
import { DistinctFieldValue } from '../../../modules/entries/types';
import { FieldFilter, SortOrders } from '../../../stores/types';
import { FilterOption } from './types';

export const getSortIcon = (
  fieldName?: string,
  sortOrder?: SortOrders,
  sortBy?: string,
): IconValueProps => {
  if (fieldName !== sortBy) {
    return { asset: 'Sort' };
  }
  if (sortOrder === 'ASC') {
    return { asset: 'ArrowUp' };
  }
  if (sortOrder === 'DESC') {
    return { asset: 'ArrowDown' };
  }
  return { asset: 'Sort' };
};

const getFilterDisplayValue = (distinctFieldValue: DistinctFieldValue): string => {
  const { value, resolvedValue } = distinctFieldValue;
  if (typeof value === 'boolean') {
    return booleanToOptionText(value);
  }
  return resolvedValue ? String(resolvedValue) : String(value);
};

const buildFilterOption = (distinctFieldValue: DistinctFieldValue, isSelected: boolean) => ({
  displayValue: getFilterDisplayValue(distinctFieldValue),
  filterValue: distinctFieldValue.value,
  selected: isSelected,
});

export const processFilterOptions = (
  distinctFieldValues?: DistinctFieldValue[],
  fieldFilters?: FieldFilter[],
  dropSelectedOptions?: boolean,
): FilterOption[] => {
  const selectedOptions: FilterOption[] = [];
  const filterOptions: FilterOption[] = [];

  distinctFieldValues?.forEach((distinctFieldValue) => {
    const isSelected = !!fieldFilters?.find(filter => filter.filterValue === distinctFieldValue.value);
    const filterOption = buildFilterOption(distinctFieldValue, isSelected);
    if (isSelected) {
      selectedOptions.push(filterOption);
      return;
    }
    filterOptions.push(filterOption);
  });

  return dropSelectedOptions
    ? filterOptions
    : [...selectedOptions, ...filterOptions];
};

export const processExistingFilters = (fieldFilters?: FieldFilter[]): FilterOption[] => {
  return fieldFilters?.map((fieldFilter) => ({
    displayValue: fieldFilter.displayValue,
    filterValue: fieldFilter.filterValue,
    selected: true,
  })) || [];
};

export const aggregateAllOptions = (
  queriedFilterOptions: FilterOption[],
  appliedFilterOptions: FilterOption[],
  hasSearchQuery?: boolean,
): FilterOption[] => {
  const allFilterOptions = hasSearchQuery
    ? queriedFilterOptions
    : [...appliedFilterOptions, ...queriedFilterOptions];
  return allFilterOptions.slice(0, FILTER_DROPDOWN_OPTIONS);
};
